import React, { PureComponent } from 'react';
import { bool, func, number, string } from 'prop-types';
import styled from 'styled-components';

import CheckSvg from 'library/icons/check.svg';
import { SafeJSONParse } from 'library/helpers/text';

const StyledContainer = styled.div`
  background: #f5f5f2;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  transition: all .15s ease-in-out;
  margin-bottom: 1em;
`;

const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

const StyledCheckBox = styled.div`
  height: 67px;
  width: 100%;
  display: flex;

  ${HiddenCheckbox}:focus + & {
    box-shadow: 0 0 0 3px pink;
  }
`;

const StyledLabel = styled.span`
  font-size: 16px;
  font-weight: 500;
  margin: auto .5em;
  width: 100%;

  @media (min-width: 600px) {
    font-size: 20px;
  }
`;

const StyledBox = styled.div`
  background: #fff;
  text-align: center;
  color: #797979;
  width: 30px;
  height: 25px;
  margin: auto .5em;
  display: flex;
  span {
    width: 100%;
    height: 100%;
    font-size: 16px;
    font-weight: bold;
  }
`;

const StyledCheckSvg = styled(CheckSvg)`
  g {
    g {
      fill: green;
    }
  }
`;

class Checkbox extends PureComponent {
  static propTypes = {
    label: string,
    onChange: func,
    value: bool,
    id: number,
    name: string,
  }

  static getDerivedStateFromProps = (props, state) => {
    let value = SafeJSONParse(props.value);

    if (value != state.checked) {
      return {
        checked: value
      };
    }
    return null;
  }

  state = {
    checked: false,
  }

  handleOnChange = () => {
    const { name, id } = this.props;
    this.props.onChange({target: {id, key: name, value: !this.state.checked }});
    this.setState(() => ({
      checked: !this.state.checked,
    }));
  };

  getIcon = () => this.state.checked ? (
    <StyledCheckSvg />
  ) : null;

  render = () => (
    <StyledContainer onClick={this.handleOnChange}>
      <HiddenCheckbox defaultChecked={this.state.checked} />
      <StyledCheckBox checked={ this.state.checked}>
        <StyledLabel>{this.props.label}</StyledLabel>
        <StyledBox><span>{this.getIcon()}</span></StyledBox>
      </StyledCheckBox>
    </StyledContainer>
  );
}

export default Checkbox;
